"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var AXSBlock_1 = __importDefault(require("../../AXSBlock/AXSBlock"));
var EventImage = styled_components_1.default(AXSBlock_1.default)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background-image: ", ";\n  background-position: center;\n  background-size: cover;\n  display: block;\n  height: ", ";\n  width: 100%;\n"], ["\n  background-image: ", ";\n  background-position: center;\n  background-size: cover;\n  display: block;\n  height: ", ";\n  width: 100%;\n"])), function (_a) {
    var url = _a.url;
    return "url(" + url + ")";
}, function (_a) {
    var height = _a.height;
    return height;
});
var AXSCardImage = function (_a) {
    var url = _a.url, height = _a.height, borderRadius = _a.borderRadius, borderRadiusBottomLeft = _a.borderRadiusBottomLeft, borderRadiusBottomRight = _a.borderRadiusBottomRight, borderRadiusTopLeft = _a.borderRadiusTopLeft, borderRadiusTopRight = _a.borderRadiusTopRight, props = __rest(_a, ["url", "height", "borderRadius", "borderRadiusBottomLeft", "borderRadiusBottomRight", "borderRadiusTopLeft", "borderRadiusTopRight"]);
    return (React.createElement(EventImage, __assign({ borderRadius: borderRadius, borderRadiusBottomLeft: borderRadiusBottomLeft, borderRadiusBottomRight: borderRadiusBottomRight, borderRadiusTopLeft: borderRadiusTopLeft, borderRadiusTopRight: borderRadiusTopRight, url: url, height: height }, props)));
};
AXSCardImage.defaultProps = {
    height: '100px',
};
exports.default = AXSCardImage;
var templateObject_1;
//# sourceMappingURL=index.js.map